/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Confirmation_DescriptionInputs */

const en_delete_account_confirmation_description = /** @type {(inputs: Delete_Account_Confirmation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone`)
};

const es_delete_account_confirmation_description = /** @type {(inputs: Delete_Account_Confirmation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción no se puede deshacer.`)
};

const ar_delete_account_confirmation_description = /** @type {(inputs: Delete_Account_Confirmation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يمكن التراجع عن هذا الإجراء.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone" |
*
* @param {Delete_Account_Confirmation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_confirmation_description = /** @type {((inputs?: Delete_Account_Confirmation_DescriptionInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Confirmation_DescriptionInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_confirmation_description(inputs)
	if (locale === "es") return es_delete_account_confirmation_description(inputs)
	return ar_delete_account_confirmation_description(inputs)
});